import React, { useMemo } from 'react'
import { FormValues, useAllTransactionContext } from '../index.context'
import { Controller } from 'react-hook-form'
import CustomInput from 'src/app/shared/components/common/input'
import { validateOnBlur } from 'src/app/shared/utils/String.util'
import { useTranslation } from 'react-i18next'
import { Flex } from 'antd'
import CustomRangePicker from 'src/app/shared/components/common/range-picker'
import CustomSelect from 'src/app/shared/components/common/select'
import { inputDecimalNumber } from 'src/app/shared/utils'
import { useFormRules } from '../index.constant'
import { useWindowSize } from 'src/app/shared/hooks/useWindowSize'

const AchForm: React.FC = () => {
  const { form, gettingData, disabled, options } = useAllTransactionContext()
  const { clientOptions, accountOptions, secCodeOptions } = useMemo(() => options, [options])
  const { amountTo } = useFormRules(form)
  const { mode } = useWindowSize()
  const { t } = useTranslation()

  return (
    <Flex
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
      }}
    >
      <Controller
        control={form.control}
        name='clientIds'
        render={({ field, fieldState }) => (
          <CustomSelect
            label={t('AllTransactions:title.client')}
            placeholder={t('AllTransactions:placeholder.client')}
            value={field.value}
            onChange={field.onChange}
            onBlur={() => validateOnBlur<FormValues>('clientIds', field, form)}
            error={fieldState.error}
            loading={gettingData}
            options={clientOptions}
            disabled={disabled}
            haveAllOption
            showSearch
          />
        )}
      />
      <Controller
        control={form.control}
        name='accountIds'
        render={({ field, fieldState }) => (
          <CustomSelect
            label={t('AllTransactions:title.account_name')}
            placeholder={t('AllTransactions:placeholder.account_name')}
            value={field.value}
            onChange={field.onChange}
            onBlur={() => validateOnBlur<FormValues>('accountIds', field, form)}
            error={fieldState.error}
            loading={gettingData}
            options={accountOptions}
            haveAllOption
            showSearch
          />
        )}
      />
      <Flex style={{ flexDirection: mode === 'mobile' ? 'column' : undefined, gap: 24 }}>
        <Controller
          control={form.control}
          name='paidDate'
          render={({ field, fieldState }) => (
            <CustomRangePicker
              label={t('AllTransactions:title.paid_date')}
              allowEmpty={[true, true]}
              value={field.value}
              onChange={field.onChange}
              onBlur={() => validateOnBlur<FormValues>('paidDate', field, form)}
              error={fieldState.error}
              allowClear
            />
          )}
        />
        <Controller
          control={form.control}
          name='secCode'
          render={({ field, fieldState }) => (
            <CustomSelect
              label={t('AllTransactions:title.sec_code')}
              placeholder={t('AllTransactions:placeholder.sec_code')}
              value={field.value}
              onChange={field.onChange}
              onBlur={() => validateOnBlur<FormValues>('secCode', field, form)}
              error={fieldState.error}
              options={secCodeOptions}
              loading={gettingData}
              allowClear
              showSearch
              sortWithAll
            />
          )}
        />
      </Flex>
      <Flex style={{ flexDirection: mode === 'mobile' ? 'column' : undefined, gap: 24 }}>
        <Controller
          control={form.control}
          name='amountFrom'
          render={({ field, fieldState }) => (
            <CustomInput
              label={t('AllTransactions:title.amount')}
              placeholder={t('AllTransactions:placeholder.from')}
              value={field.value}
              onChange={(e) => field.onChange(inputDecimalNumber(e), { shouldValidate: true })}
              onBlur={() => validateOnBlur<FormValues>(['amountFrom', 'amountTo'], field, form)}
              error={fieldState.error}
              suffix={'$'}
            />
          )}
        />
        <Controller
          control={form.control}
          name='amountTo'
          render={({ field, fieldState }) => (
            <div style={{ flex: 1 }}>
              <div
                style={{
                  height: 22,
                }}
              />
              <CustomInput
                placeholder={t('AllTransactions:placeholder.to')}
                value={field.value}
                onChange={(e) => field.onChange(inputDecimalNumber(e), { shouldValidate: true })}
                onBlur={() => validateOnBlur<FormValues>('amountTo', field, form)}
                error={fieldState.error}
                suffix={'$'}
              />
            </div>
          )}
          rules={amountTo}
        />
      </Flex>
    </Flex>
  )
}

export default AchForm
